import React from "react";
import { buildMonthCells, isSameDay, isInRange } from "./dateRangeUtils";

const WEEKDAY_LABELS = ["S", "M", "T", "W", "T", "F", "S"];

const MonthGrid = ({ monthDate, rangeStart, rangeEnd, onSelectDay }) => {
	const cells = buildMonthCells(monthDate);
	const today = new Date();

	return (
		<div style={{ width: 220 }}>
			<div style={{ textAlign: "center", fontSize: 12, fontWeight: 700, color: "var(--color-text)", marginBottom: 8 }}>
				{monthDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })}
			</div>
			<div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2 }}>
				{WEEKDAY_LABELS.map((w, i) => (
					<div key={i} style={{ fontSize: 10, fontWeight: 600, color: "var(--color-text-light)", textAlign: "center", padding: "4px 0" }}>{w}</div>
				))}
				{cells.map((day, i) => {
					if (!day) return <div key={i} />;
					const isStart = isSameDay(day, rangeStart);
					const isEnd = isSameDay(day, rangeEnd);
					const inRange = isInRange(day, rangeStart, rangeEnd);
					const isToday = isSameDay(day, today);
					return (
						<button
							key={i}
							onClick={() => onSelectDay(day)}
							style={{
								width: 28, height: 28, borderRadius: isStart || isEnd ? 8 : inRange ? 0 : 8,
								border: isToday && !isStart && !isEnd ? "1px solid #6f42c1" : "none",
								background: isStart || isEnd ? "#6f42c1" : inRange ? "rgba(111,66,193,0.14)" : "transparent",
								color: isStart || isEnd ? "#fff" : "var(--color-text)",
								fontSize: 12, fontWeight: isStart || isEnd ? 700 : 500,
								cursor: "pointer", transition: "background 0.1s",
							}}
						>
							{day.getDate()}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default MonthGrid;
